import React from 'react';

import AnswerPanel from 'components/customer/answer_panel';
import connect from 'components/lib/connect';
import { SidePanelType } from 'models/side_panel';
import TaskCommentPanel from 'components/customer/task_comments/task_comment_panel';

function CustomerSidePanel({ isAnswersReadEnabled, sidePanel }) {
  if (!sidePanel || !sidePanel.isOpen()) {
    return null;
  }

  if (sidePanel.isShowing(SidePanelType.ANSWER) && isAnswersReadEnabled) {
    return <AnswerPanel />;
  }

  if (sidePanel.isShowing(SidePanelType.TASK)) {
    return <TaskCommentPanel />;
  }

  return null;
}

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  const sidePanel = getProvider('sidePanel').get();
  const isAnswersReadEnabled = isFeatureEnabled('answers:read');

  return {
    isAnswersReadEnabled,
    sidePanel,
  };
}

export default connect(mapStateToProps)(CustomerSidePanel);
